const isThisMonth = (timestamp)=>{
    let currentMonth = new Date().getMonth()
    let invoiceMonth = new Date(timestamp).getMonth()

    return currentMonth === invoiceMonth
}

export default isThisMonth